import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./global.css";
import { Header } from "./header/Header";
import { Leaderboard, LeaderboardBrand } from "./leaderboard/Leaderboard";
import { Calculator } from "./calculator/Calculator";
import { LeaderboardResults } from "./leaderboard/results/Leaderboard-Results";

function App() {
  return (
    <div className="root">
      <Router>
        <Header />

        <Routes>
          <Route
            path="/csgoroll/leaderboard"
            element={
              <Leaderboard
                brand={LeaderboardBrand.CSGOROLL}
                month="november"
                from="01.11.2026"
                to="30.11.2026"
                lastUpdate="03.10.2026."
                lastPeriodTotalDeposit={0}
              />
            }
          />

          <Route path="/calculator" element={<Calculator />} />
          {/* <Route
            path="/leaderboard_previous"
            element={
              <LeaderboardResults
                title="May"
                dataSource="may"
                ended={true}
                timestamp="31.05. at 23:59 PM CEST"
              />
            }
          /> */}
          <Route
            path="*"
            element={
              <Leaderboard
                brand={LeaderboardBrand.CSGOROLL}
                month="november"
                from="01.11.2026"
                to="30.11.2026"
                lastUpdate="03.10.2026."
                lastPeriodTotalDeposit={0}
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
